import {
  CurrencyCode,
  InvoicePricingBasis,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createInboundTollingAgreementAtom = createMutationAtomFactory(
  'production.createInboundTollingAgreement',
  (params: {
    agreementNumber: string;
    customerAccountId: string;
    processingTypeId: string;
    effectiveDate: string;
    expirationDate?: string;
    pricePerUnit?: { amount: number; currencyCode: CurrencyCode };
    priceUnit?: string;
    expectedYieldPercentage?: number;
    terms?: string;
    isActive: boolean;
    invoicePricingBasis: InvoicePricingBasis;
    facilityId: string;
  }) => ({
    productionInboundTollingAgreementCreate: {
      __args: {
        input: {
          agreementNumber: params.agreementNumber,
          customerAccountId: params.customerAccountId,
          processingTypeId: params.processingTypeId,
          effectiveDate: params.effectiveDate,
          expirationDate: params.expirationDate,
          pricePerUnit: params.pricePerUnit,
          priceUnit: params.priceUnit,
          expectedYieldPercentage: params.expectedYieldPercentage,
          terms: params.terms,
          isActive: params.isActive,
          invoicePricingBasis: params.invoicePricingBasis,
          facilityId: params.facilityId,
        },
      },
      id: true,
      agreementNumber: true,
    },
  }),
);

export const updateInboundTollingAgreementAtom = createMutationAtomFactory(
  'production.updateInboundTollingAgreement',
  (params: {
    id: string;
    agreementNumber?: string;
    expirationDate?: string;
    pricePerUnit?: { amount: number; currencyCode: CurrencyCode };
    priceUnit?: string;
    expectedYieldPercentage?: number;
    terms?: string;
    isActive?: boolean;
    invoicePricingBasis?: InvoicePricingBasis;
  }) => ({
    productionInboundTollingAgreementUpdate: {
      __args: {
        id: params.id,
        input: {
          agreementNumber: params.agreementNumber,
          expirationDate: params.expirationDate,
          pricePerUnit: params.pricePerUnit,
          priceUnit: params.priceUnit,
          expectedYieldPercentage: params.expectedYieldPercentage,
          terms: params.terms,
          isActive: params.isActive,
          invoicePricingBasis: params.invoicePricingBasis,
        },
      },
      id: true,
      agreementNumber: true,
    },
  }),
);
